<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test Reports">
        <br />
        <div class="row">
          <div class="col-md-6 form-group">
            Test Type
            <b-form-select v-model="type" @input="typeEmpty = false,gettests()" required>
              <option value="subscription_practice_test">Practice Test</option>
              <option value="subscription_mock_test">Mock Test</option>
            </b-form-select>
            <div v-if="typeEmpty" style="color: red">Test Type is required</div>
          </div>
          <div class="col-md-6 form-group">
            Subscription
             <b-form-select v-model="subscription" @input="subscriptionEmpty = false,gettests()" @change="getSubscriptions()" required>
              <option
                v-for="(subscription, index) in subscriptions"
                :key="index"
                :value="subscription.subscriptions.id"
              >
                {{ subscription.subscriptions.name }}
              </option>
            </b-form-select>
            <div v-if="subscriptionEmpty" style="color: red">
              Subscription is required
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Choose Type </label><small style="color: red">*</small>
                <b-form-select v-model="choosetype" @input="choosetypeEmpty = false"
                @change="getHods()" required>
                  <option value="College Purchase Hod">Hod </option>
                  <option value="College Purchase Class">Class </option>
                </b-form-select>
              <div class="form-group" style="color: red" v-if="choosetypeEmpty">
                Choose Type is Required
              </div>                
            </div>              
          </div>
          <div class="col-md-12" v-if="choosetype == 'College Purchase Hod'">
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Hod </label>
                <b-form-select v-model="hod" @input="hodEmpty = false,gettests()" required>
                    <option
                      v-for="(hod, index) in hods"
                      :key="index"
                      :value="hod.id"
                    >
                      {{ hod.username }}
                    </option>
                  </b-form-select>
                <div class="form-group" style="color: red" v-if="hodEmpty">
                  Hod is Required
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="choosetype == 'College Purchase Class'">
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Hod </label>
                <b-form-select v-model="hod" @input="hodEmpty = false" required>
                    <option
                      v-for="(hod, index) in hods"
                      :key="index"
                      :value="hod.id"
                    >
                      {{ hod.username }}
                    </option>
                  </b-form-select>
                <div class="form-group" style="color: red" v-if="hodEmpty">
                  Hod is Required
                </div>
              </div>

              <div class="col-md-6 form-group" v-if="hod">
                <label>Class </label>
                <b-form-select v-model="hodclass" @input="hodclassEmpty = false,gettests()" required>
                    <option
                      v-for="(hodclass, index) in classes"
                      :key="index"
                      :value="hodclass.id"
                    >
                      {{ hodclass.username }}
                    </option>
                  </b-form-select>
                <div class="form-group" style="color: red" v-if="hodclassEmpty">
                  Class is Required
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-table-simple
          responsive
          bordered
          striped
          table-class="table-vcenter"
          v-if="tests.length > 0"
        >                
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Test Name</b-th>
              <b-th class="text-center">Test Type</b-th>
              <b-th class="text-center">No Of Questions</b-th>
              <b-th class="text-center">Negative Mark</b-th>
              <b-th class="text-center">Each Question Mark</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(test, index) in tests" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center"> {{ test.name }} </b-td>
              <b-td class="text-center" v-if="test.type == 'subscription_mock_test'">
                {{ test.tests.test_type }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.test_type }}
              </b-td>
               <b-td class="text-center" v-if="test.type == 'subscription_mock_test'">
                {{ test.tests.no_of_questions }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.no_of_questions }}
              </b-td>
               <b-td class="text-center" v-if="test.type == 'subscription_mock_test'">
                {{ test.tests.negative_mark }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.negative_mark }}
              </b-td>
                <b-td class="text-center" v-if="test.type == 'subscription_mock_test'">
                {{ test.tests.each_question_mark }}
              </b-td>
              <b-td class="text-center" v-else>
                {{ test.each_question_mark }}
              </b-td>
              <b-td class="text-center" v-if="test.type == 'subscription_mock_test'">
                <b-btn-group v-if="hod && hodclass">
                  <router-link
                    :to="{
                      name: 'College User Test Attended',
                      params: {
                         collegeName: $route.params.collegeName,
                         collegeId: $route.params.collegeId,
                         testId: test.tests.id,
                         collegeAdminId: hodclass,
                      },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
                <b-btn-group v-else-if="hod">
                  <router-link
                    :to="{
                      name: 'College User Test Attended',
                      params: {
                         collegeName: $route.params.collegeName,
                         collegeId: $route.params.collegeId,
                         testId: test.tests.id,
                         collegeAdminId: hod,
                      },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
               <b-td class="text-center" v-else>
                <b-btn-group v-if="hod && hodclass">
                  <router-link
                    :to="{
                      name: 'College User Test Attended',
                      params: {
                         collegeName: $route.params.collegeName,
                         collegeId: $route.params.collegeId,
                         testId: test.id,
                         collegeAdminId: hodclass,
                      },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
                <b-btn-group v-else-if="hod">
                  <router-link
                    :to="{
                      name: 'College User Test Attended',
                      params: {
                         collegeName: $route.params.collegeName,
                         collegeId: $route.params.collegeId,
                         testId: test.id,
                         collegeAdminId: hod,
                      },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tests: [],
      type: "",
      typeEmpty: false,
      choosetype: "",
      choosetypeEmpty: false,
      subscriptions: [],
      departments: [],
      hods: [],
      classes: [],
      hodclass:"",
      hodclassEmpty: false,
      subscription :"",
      subscriptionEmpty: false,
      department :"",
      departmentEmpty: false,
      hod :"",
      hodEmpty: false,
      class :"",
      classEmpty: false,
    };
  },
  mounted() {
    this.getSubscriptions();
    this.getDepartments();
    this.getHods();
    this.getClasses();
    // this.getExports();
  },
  methods: {
    async getSubscriptions() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_subscriptions
`,         {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            console.log("subscription")
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async getDepartments() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/departments`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
      console.log("departments");
          console.log(response);
          if (response.data.status == "success") {
            this.departments = response.data.departments;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getExports(subid, testid, type, college_admin_id){
       await axios
         .get(
          `${this.$store.getters.baseUrl}/college-sub-userExcel/${subid}/${testid}/${type}`,
          {
          headers: { Authorization: `Bearer ${this.$store.getters.token}`},
        })
        .then((response) => {
          const link = document.createElement("a");
          link.href = response.data.url + '/' + college_admin_id;
          console.log("collegeAdminId");
          console.log(college_admin_id);
          console.log(response.data.url + '/' + college_admin_id);
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
          
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getHods() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/hods`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
      console.log("hods");
          console.log(response);
          if (response.data.status == "success") {
            this.hods = response.data.hods;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async getClasses() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/classes`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
      console.log("classes");
          console.log(response);
          if (response.data.status == "success") {
            this.classes = response.data.classes;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },


     async gettests() {

       if(this.type == "") {
        this.typeEmpty = true;
        return;
      }

       if(this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      } 
      if(this.choosetype == "") {
        this.choosetypeEmpty = true;
        return;
      }
      console.log('check');
       const formdata = new FormData();
      formdata.append("type", this.type);
      formdata.append("sub_id", this.subscription);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/alltests-list`,formdata,         {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            console.log("testlist");
            this.tests = response.data.tests;
             if (!this.tests.length > 0) {
              this.$swal({
                title: "Info",
                text: "No test found on given Subscription",
                icon: "warning",
              });
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
